import Role from '../entities/role';

const roledDataTransformationAfterFetch = (data) => {
    return data.map((row) => {
        return new Role(row);
    });
};

export default roledDataTransformationAfterFetch;
